import React from "react";
import GlobalForm from "../../components/globalForm/GlobalForm";
import Loading from "../../components/shared/loading/Loading";
import { updateData } from "../../hooks/update";
import useFetch from "../../hooks/useFetch";
import { apiPath } from "../../utility/Constant";

const ServiceContentPage = () => {
  const { serviceContentApi } = apiPath;
  const [homeService, homeServiceLoading] = useFetch(serviceContentApi);
  if (homeServiceLoading) {
    return <Loading />;
  }

  const { sectionBg, sectionTitle } = homeService;

  const data = [
    {
      elementType: "file",
      label: "Banner Image",
      type: "Text",
      name: "sectionBg",
      defaultValue: sectionBg,
      required: true,
    },
    {
      elementType: "input",
      label: "Banner Title",
      type: "Text",
      name: "sectionTitle",
      defaultValue: sectionTitle,
      required: false,
    },
  ];

  const update = (data) => {
    updateData(serviceContentApi, data);
  };

  return (
    <div>
      <GlobalForm data={data} update={update} />
    </div>
  );
};

export default ServiceContentPage;
